import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { setearDatosAlStore } from 'store/actions/customAction';
import Formulario from 'components/formulario';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';

const DatosDeLaRadio = ({activeStep, numberStep, handleClose, datosDeLaRadio}) => {
    const dispatch = useDispatch();
    const {tarifarioYDisponibilidad} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const { nombreDeLaRadio, estacion, frecuencia, logoRadio, descripcionRadio, correoElectronico, diasDeAnticipacion, comentarioEspecificaciones, estaRegistrandoRadio } = datosDeLaRadio;

    useEffect(() => {
        validarDisponibilidad()
    }, [])

    const validarDisponibilidad = () => {
        const copiaElements = Object.assign({}, elements);
        if(tarifarioYDisponibilidad?.disponibilidades?.length > 0) {
            copiaElements.alertaDisponibilidad.showAlertForm = true
            copiaElements.estaRegistrandoRadio.disabled = true;
        } else {
            copiaElements.alertaDisponibilidad.showAlertForm = false
            copiaElements.estaRegistrandoRadio.disabled = false
        }

        setElements(copiaElements);
    }

    const [elements, setElements] = React.useState({
        tituloDatosDeRadio:{
            idelement: "tituloDatosDeRadio", title:'Datos de la radio', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDeRadio", value: "", isError:false,
        },
        nombreDeLaRadio: {
            idelement: "nombreDeLaRadio", value: nombreDeLaRadio, label: "Nombre de la radio *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,100}$", validators: ['required'], errorMessages:['El campo es requerido, sin espacios al inicio y final'], isError:false, elementType:'texto', name:"nombreDeLaRadio", 'disabled': false, width: '25%'
        },
        estacion: {
            idelement: "estacion", value: estacion, label: "Estación *", pattern:"^\\d+(.[0-9]{1})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"estacion", 'disabled': false, width: '25%'
        },
        frecuencia: {
          idelement: "frecuencia", value: frecuencia , label: "Frecuencia *", pattern:"", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "AM"}, {id: 2, name: "FM"}], handler: undefined, width: '25%'
        },
        logoRadio:{
            idelement: "logoRadio", value: logoRadio, label: "LOGO", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"logoRadio", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '25%', type: "file"
        },
        descripcionRadio:{
            idelement: "descripcionRadio", value: descripcionRadio, label: `Descripción de la radio`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionRadio", width: '100%'
        },

        tituloEspecificaciones:{
            idelement: "tituloEspecificaciones", title:'Especificaciones Técnicas', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEspecificaciones", value: "", isError:false,
        },
        correoElectronico: {
          idelement: "correoElectronico", value: correoElectronico, label: "Correo electrónico para recepción de materiales *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%"
        },
        diasDeAnticipacion: {
            idelement: "diasDeAnticipacion",  value: diasDeAnticipacion, label: "Días de anticipación para entregar el material a pautar *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diasDeAnticipacion", 'disabled': false, width: "50%"
        },
        comentarioEspecificaciones:{
            idelement: "comentarioEspecificaciones", value: comentarioEspecificaciones, label: `Especificaciones técnicas del material`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioEspecificaciones", width: '100%'
        },
        tituloRegistroPrograma:{
            idelement: "tituloRegistroPrograma", title:'Registro de programas que se transmite en un radio de tercero', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRegistroPrograma", value: "", isError:false,
        },
        alertaDisponibilidad:{
            idelement: "alertaDisponibilidad", mensaje:'PARA MODIFICAR ESTE CAMPO, DEBE ELIMINAR EL LISTADO DE DISPONIBILIDADES REGISTRADAS', elementType:'alerta', showAlertForm: false, name: "alertaDisponibilidad", value: "", isError:false, severity: 'error'
        },
        estaRegistrandoRadio:{
          idelement: "estaRegistrandoRadio", value: estaRegistrandoRadio, label: "¿Esta registrando programas que se transmite en un radio de tercero? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [ { value: "1", label: 'SI' }, { value: "2", label: 'NO' }], 'disabled':false, isRequired: true,
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const cancelarAccion = () => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        handleClose();
    };

    const siguientePaso = async (dataForm) => {
        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SETEAR_DATOS_DE_LA_RADIO,
            data: {
                datosDeLaRadio: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const [buttonList]= React.useState({
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <NavigateNext />,"callback":cancelarAccion,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => {
        setResponseData({errorType,messageType,openResponse,})
    };

    const { errorType, messageType, openResponse} = responseData;

    return (
        <Fragment>
            <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elements}
                        buttonList={buttonList}
                    />
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default DatosDeLaRadio;